import type { ReactNode } from 'react';

const DebuggerInfo = ({ took, children, show }: IProps) => {
	if (!show) {
		return null;
	}
	return (
		<div style={{ fontSize: '14px' }}>
			Debugger 🤓
			<br />
			<span
				style={{
					fontFamily: 'monospace',
					backgroundColor: 'lightgrey',
				}}
			>
				{children}
			</span>
			<br />
			took: {took}ms
			<br />
		</div>
	);
};

interface IProps {
	took: number | string;
	show: boolean;
	children?: ReactNode;
}

export default DebuggerInfo;
